const init = () => {
  const intersectionOptions = { threshold: 0.5 }

  const trackComponent = (eventGrouping, eventName, eventData, trackProps) => {
    const additionalTrackProps = { event_name: eventName }
    if (eventData) {
      for (const key in eventData) {
        if (typeof eventData[key] === 'object') {
          console.warn('Please do not nest objects in eventData as it is difficult to parse')
        }
      }
      additionalTrackProps.event_data = JSON.stringify(eventData)
    }
    return window.nerdalytics.track(eventGrouping, { ...trackProps, ...additionalTrackProps })
  }

  const components = document.querySelectorAll('[data-component-tracking]')

  const handleIntersection = (entries, observer) => {
    entries
      .filter(
        entry => entry.isIntersecting && entry.intersectionRatio >= intersectionOptions.threshold,
      )
      .forEach(entry => {
        const trackingProps = JSON.parse(entry.target.getAttribute('data-component-tracking'))
        trackComponent('Static Component Event', 'viewed', undefined, trackingProps)
        observer.unobserve(entry.target)
      })
  }

  const observer = new IntersectionObserver(handleIntersection, intersectionOptions)

  Array.from(components).forEach(component => {
    // Disable 'Component Loaded' events whilst perf is a concern
    // const trackingProps = JSON.parse(component.getAttribute('data-component-tracking'))
    // trackComponent('Static Component Event', 'loaded', undefined, trackingProps)
    observer.observe(component)
  })
}

export default init
